module.exports = __webpack_public_path__ + "images/PANORAMIC___VUE_INTERIEURE_LOT_B24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/PANORAMIC___VUE_INTERIEURE_LOT_B24.jpg
// module id = 878
// module chunks = 0